import { useEffect, useState, useMemo, useCallback } from "react";
import WebSocketManager from "../../../../ws/client";

export function useComboLiveUpdate(initialCombo) {
  const [liveCombo, setLiveCombo] = useState(initialCombo);

  useEffect(() => {
    setLiveCombo(initialCombo);
  }, [initialCombo]);

  const targetId = useMemo(() => {
    return initialCombo?.combo_id || initialCombo?.id;
  }, [initialCombo]);

  const topic = useMemo(() => {
    if (!targetId) return null;
    return `/topic/combo-${targetId}`;
  }, [targetId]);

  const handleMessage = useCallback((event) => {
    try {
      const { type, payload } = event;

      if (type === "UPDATED") {
        const normalizedPayload = {
          ...payload,
          combo_id: payload.id || payload.combo_id,
          itemsList: payload.items_list || payload.itemsList,
          nutritionalFacts: payload.nutritional_facts,
          imageUrl: payload.image_url
        };
        setLiveCombo(normalizedPayload);
      }
    } catch (err) {
      console.error("Erro ao processar update live do combo:", err);
    }
  }, []);

  useEffect(() => {
    if (!topic) return;

    WebSocketManager.subscribe(topic, handleMessage);

    return () => {
      WebSocketManager.unsubscribe(topic);
    };
  }, [topic, handleMessage]);

  return liveCombo;
}